var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66 0H0V66H66V0Z",
    fill: "#6D9177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8411 35.5075C21.2471 34.9795 20.3231 35.0455 19.7951 35.6395C19.2671 36.1675 19.2671 37.0255 19.7951 37.5535L25.6691 43.4275C25.9991 43.7575 25.9991 44.2195 25.6691 44.5495C25.3391 44.8795 24.8771 44.8795 24.5471 44.5495L18.6731 38.6755C17.4851 37.4875 17.4851 35.6395 18.6731 34.4515C18.7391 34.3855 18.8051 34.3195 18.8711 34.2535V27.5215C18.8711 26.6635 18.1451 25.9375 17.2871 25.9375C16.4291 25.9375 15.7031 26.6635 15.7031 27.5215V40.6555C15.7031 42.1075 16.2971 43.4935 17.2871 44.5495L23.8871 51.1495H32.2031V50.0935C32.2031 47.4535 31.1471 44.9455 29.2991 43.0315L21.8411 35.5075Z",
    fill: "#ECE9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8228 26.4025C49.2288 25.8085 48.2388 25.8085 47.5788 26.4025C47.3148 26.6665 47.1168 27.0625 47.1168 27.5245C47.1168 35.0485 47.0507 34.2565 47.3147 34.4545C48.5027 35.6425 48.5027 37.5565 47.3147 38.7445L41.4408 44.6185C41.1108 44.9485 40.6488 44.9485 40.3188 44.6185C39.9888 44.2885 39.9888 43.8265 40.3188 43.4965L46.1928 37.6225C46.7208 37.0285 46.7208 36.1705 46.1928 35.5765C46.1268 35.5105 46.0607 35.4445 45.9947 35.3785C45.4007 34.9825 44.6748 35.1145 44.2128 35.5765L36.6888 43.0345C34.8408 44.8825 33.7848 47.3905 33.7188 50.0305V51.0865H42.0348L48.6347 44.4865C49.6247 43.4305 50.2188 42.0445 50.2188 40.5925C50.2847 26.5345 50.4828 27.0625 49.8228 26.4025Z",
    fill: "#ECE9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8486 29.042C40.8486 24.686 32.9946 14.918 32.9946 14.918C32.9946 14.918 25.1406 24.752 25.1406 29.042C25.1406 33.398 28.6386 36.962 32.9946 36.962C37.3506 36.962 40.8486 33.398 40.8486 29.042ZM32.9946 34.586C32.5326 34.586 32.2026 34.256 32.2026 33.794C32.2026 33.332 32.5326 33.002 32.9946 33.002C35.1726 33.002 36.9546 31.22 36.9546 29.042C36.9546 28.58 37.2846 28.25 37.7466 28.25C39.7266 28.316 37.9446 34.586 32.9946 34.586Z",
    fill: "#ECE9DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9986 66.0036V42.5736L50.0266 26.6016C50.4226 27.1296 50.2906 28.3836 50.2906 40.5936C50.2906 42.0456 49.7626 43.4316 48.7066 44.4876L42.1066 51.0876H32.2066H23.8906L38.8066 66.0036H65.9986Z",
    fill: "#587660"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconSeven);
export default __webpack_public_path__ + "static/media/shadow-icon-seven.59758f3e2001ba11372cfbb463297523.svg";
export { ForwardRef as ReactComponent };